// Opt in only after the new EventHub API is deployed to the same environment.
export const individualAttendanceEnabled = import.meta.env.VITE_INDIVIDUAL_ATTENDANCE === 'true';
export const partyNotificationsEnabled = individualAttendanceEnabled
  && import.meta.env.VITE_PARTY_NOTIFICATIONS === 'true';
